interface CornerProps {
  left?: boolean
}

export const Corner = ({ left }: CornerProps) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`absolute bottom-0 aspect-square w-5 ${left ? '-left-2' : '-right-2'}`}
    style={{
      transform: left ? 'rotateY(180deg)' : ''
    }}
  >
    <path
      d="M15.5965 16.5398C10.5594 17.5245 5.32953 15.4632 3.56788 14.0436C4.96201 10.5363 -1.58115 4.05488 0.729237 2.49673C2.31468 2.39699 2.93228 -0.899035 8.92274 1.38136C9.03416 2.44856 9.32714 6.14848 9.38056 6.7782C10.1202 15.4967 16.5335 15.9772 15.5965 16.5398Z"
      fill="white"
    />
  </svg>
)
